import { render } from "./NewPlan.vue?vue&type=template&id=2641b9aa"
import script from "./NewPlan.vue?vue&type=script&lang=js"
export * from "./NewPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__